import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Otosole from '../block/Otosole'
import Docks from '../block/Docks'
import About from '../block/About'
import Stati from '../block/Stati'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Otosole data={data} />
        <Docks data={data} otstup={2} />
        <About data={data} />
        <Stati data={data} />
      </>
    )
  }
}

export default App